<template>
  <div>
    <div class="modal-header has-background-info-light">
      <h2 class="window-header subtitle">{{ title }}</h2>
    </div>
    <div class="box">
      <!-- employee -->
      <p class="has-text-info">
        <i
          >{{ selectedCard.employee.hiddenFirstName }}
          {{ selectedCard.employee.hiddenLastName }}</i
        >
      </p>
      <!-- kod -->
      <div class="columns">
        <div class="column has-text-centered"><label>Kod:</label></div>
        <div class="column is-four-fifths">
          <input
            class="input is-small has-text-centered has-background-info-light"
            type="text"
            v-model="selectedCard.code"
          />
        </div>
      </div>
      <!-- Važi od do -->
      <div class="columns">
        <!-- Važi od -->
        <div class="column">
          <div class="has-text-centered"><label>Važi od:</label></div>
          <date-pick
            class="date has-background-info-light"
            :format="'YYYY.MM.DD'"
            v-model="selectedCard.validFrom"
          />
        </div>
        <!-- Važi do -->
        <div class="column">
          <div class="has-text-centered"><label>Važi do:</label></div>
          <date-pick
            class="date has-background-info-light"
            :format="'YYYY.MM.DD'"
            v-model="selectedCard.validUntil"
          />
        </div>
      </div>
      <!-- R.Br. -->
      <div class="columns">
        <div class="column has-text-centered"><label>R.Br.:</label></div>
        <div class="column is-four-fifths">
          <input
            class="input is-small has-text-centered has-background-info-light"
            disabled
            type="text"
            v-model="selectedCard.cardId"
          />
        </div>
      </div>
      <!-- tip -->
      <div class="columns">
        <div class="column has-text-centered"><label>Tip:</label></div>
        <div class="column has-text-centered is-four-fifths">
          <vue-select
            class="has-background-info-light"
            type="text"
            label="name"
            :clearable="false"
            :options="types"
            :value="selectedCard.cardType"
            @input="typeSelected"
          />
        </div>
      </div>
      <!-- isActive -->
      <div class="has-text-centered">
        <label>Da li je kartica aktivna?</label>
      </div>
      <div class="is-four-fifths">
        <input
          class="has-text-centered has-background-info-light"
          type="checkbox"
          v-model="selectedCard.isActive"
        />
      </div>
      <br />
      <br />
      <!-- Buttons -->
      <div class="columns">
        <div v-show="isSaveAndProceedButtonVisible" class="column">
          <button
            class="button is-info is-light is-rounded"
            @click="saveAndProceedButtonClicked"
          >
            SAČUVAJ I NASTAVI
          </button>
        </div>
        <div class="column">
          <button
            class="button is-info is-light is-rounded"
            @click="saveAndCloseButtonClicked"
          >
            SAČUVAJ I ZATVORI
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatePick from "vue-date-pick";
import "vue-date-pick/dist/vueDatePick.css";

export default {
  name: "EditCard",

  props: {
    title: String,
    selectedCard: Object,
    isSaveAndProceedButtonVisible: Boolean,
  },

  components: { DatePick },

  data() {
    return {
      types: [
        {
          id: 1,
          name: "mifare",
        },
        {
          id: 2,
          name: "125khz",
        },
        {
          id: 3,
          name: "EPCGEN2",
        },
      ],
    };
  },
  mounted() {
    console.log("mounted!");
    this.scanForNFC();
  },
  created() {
    console.log("Created!");
  },
  updated() {
    console.log("updated!");
  },
  methods: {
    saveAndProceedButtonClicked() {
      this.$emit("saveAndProceedButtonClicked", this.selectedCard);
    },
    saveAndCloseButtonClicked() {
      this.$emit("saveAndCloseButtonClicked", this.selectedCard);
    },
    typeSelected(val) {
      this.selectedCard.cardType = val.name;
      console.log(val);
    },
    async scanForNFC() {
      console.log("User clicked scan button");
      if ("NDEFReader" in window) {
        try {
          /* eslint-disable-next-line */
          const ndef = new NDEFReader();
          await ndef.scan();
          console.log("> Scan started");

          ndef.addEventListener("readingerror", () => {
            console.log(
              "Argh! Cannot read data from the NFC tag. Try another one?"
            );
          });

          ndef.addEventListener("reading", ({ message, serialNumber }) => {
            let serialWithoutSemicolons = serialNumber.replace(/:/g, "");
            let firstEightChars = serialWithoutSemicolons.substring(0, 8);
            this.selectedCard.code = firstEightChars;
            this.selectedCard.cardType = "mifare";
            console.log(`> Serial Number: ${serialNumber}`);
            console.log(`> Records: (${message.records.length})`);
          });
        } catch (error) {
          console.log("Argh! " + error);
        }
      }
    },
  },
};
</script>